import _ from 'lodash';
import Backbone from 'backbone';
import ViewStoreModule from 'util/ViewStoreModule';

/**
 * helper for collection like structures in viewstore
 * set view and key in initialize, key is changeable afterwards
 *
 */

var ViewStoreHelperCollection = Backbone.Collection.extend({
	comparator: 'nr',
	/**
	 * @param models
	 * @param options
	 * @param {String} options.view
	 * @param {String} options.key initial value, changeable, invokes reset
	 * @param {String} options.subKey when there are multiple Collections behind sukeys i.e. {subkey1:[],subkey2:[]}
	 * @param {String} [options.saveToLocalStorage] defaults to false
	 */
	initialize: function (models, options) {
		var that = this;
		this.$_fetched = ViewStoreModule.enqueueFetch(options.view);
		this.status = new Backbone.Model({
			view: options.view,
			key: options.key,
			subKey: options.subKey
		});
		this.listenTo(this.status, 'change:key change:subKey', this.resetCollection);
		this.$_fetched.done(function () {
			that.resetCollection();
		});
	},
	statusIsValid: function () {
		return this.status.get('view') && this.status.get('key');
	},
	isInitPending: function () {
		return this.$_fetched.state() === 'pending';
	},
	getOrAdd: function (attributes) {
		if (this.$_fetched.state() === 'pending') {
			console.error('ERROR not yet initialized');
			return;
		}
		var search;
		if (attributes && !_.isPlainObject(attributes)) {
			search = {};
			search[this.model.prototype.idAttribute] = attributes;
		} else {
			search = attributes;
		}
		var model = this.findWhere(search);
		if (model) return model;
		else return this.add(search);
	},
	getNextNr: function (whereOthers) {
		var maxNr = _.max(_.map(this.where(whereOthers), function (m) {
			return m.get('nr')
		}));
		if (!_.isFinite(maxNr)) return 0;
		else return maxNr + 1;
	},
	_getOrAddCurrentVS: function () {
		if (!this.statusIsValid()) return;
		return ViewStoreModule.entries.getOrAdd(
			this.status.pick('view', 'key')
		);
	},
	_getCurrentVSModelAttr: function () {
		if (!this.statusIsValid()) return;
		var models = this._getOrAddCurrentVS().get('value');
		if (!models) return;
		var subKey = this.status.get('subKey');
		if (subKey) return models[subKey];
		else return models;
	},
	resetCollection: function () {
		if (!this.statusIsValid()) {
			this.reset();
			return;
		}
		var newModels = this._getCurrentVSModelAttr();
		this.reset(newModels);
	},
	commit: function () {
		if (!this.statusIsValid()) return;
		var vsModel = this._getOrAddCurrentVS();
		var subKey = this.status.get('subKey');
		var value;
		if (subKey) {
			value = _.assign({}, vsModel.get('value'));
			value[subKey] = this.toJSON();
		} else {
			value = this.toJSON();
		}
		vsModel.set({value: value});
	}
});

export default ViewStoreHelperCollection;